import { useEffect, useState, useRef } from 'react';

import SignaturePad from 'signature_pad';
import { SignatureProps } from './types/propTypes';
import styles from './Signature.module.scss';

const Signature = ({ callback, completed, cleared, isTouched }: SignatureProps) => {
  const signatureElement = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    setSignPad(new SignaturePad(signatureElement.current as HTMLCanvasElement));
  }, [signatureElement.current]);

  useEffect(() => {
    if (completed) {
      handleConfirm();
    }
  }, [completed]);

  useEffect(() => {
    handleClear();
  }, [cleared]);

  const [signPad, setSignPad] = useState<SignaturePad>();

  useEffect(() => {
    signPad?.addEventListener(
      'beginStroke',
      () => {
        isTouched();
      },
      { once: true },
    );
  }, [signPad, cleared]);

  const handleClear = () => {
    signPad?.clear();
  };

  const handleConfirm = () => {
    const fileData = signPad?.toDataURL();
    callback(fileData as string);
  };

  return (
    <div>
      <canvas className={styles['signature_canvas']} ref={signatureElement} data-testid="canvas"></canvas>
    </div>
  );
};
Signature.displayName = 'Signature';
export default Signature;
